import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

import { MatDialog } from "@angular/material/dialog";

import { EMPTY, Observable } from "rxjs";
import { catchError, map, pairwise, startWith } from "rxjs/operators";
import { select, Store } from "@ngrx/store";
import { AppState, loadedTenantConfigState } from "src/app/store/reducers";
import { getTenant } from "src/app/store/actions/tenant/tenant.actions";

import { TranslateService } from "@ngx-translate/core";
import { TenantService } from "../../services/tenant/tenant.service";
import { SnackbarService } from "../../services/snackbar/snackbar.service";

import { TenantDTO } from "src/app/models/Tenant/Tenant.model";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import {
  DefaultConfirmationDialogData,
  Dialog,
} from "src/app/models/dialog/dialog.model";

import { ConfirmationDialogComponent } from "../dialogs/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-tenant-select",
  templateUrl: "./tenant-select.component.html",
  styleUrls: ["./tenant-select.component.scss"],
})
export class TenantSelectComponent implements OnInit {
  @Input() set selectedTenantToken(tenantToken: string) {
    if (tenantToken) {
      this.tenantToken.setValue(tenantToken);
      this.onSelectedTenantChanges();
    }
  }
  
  tenantToken = new FormControl('');

  oldTenantToken: string;
  newTenantToken: string;

  //Tenants
  tenantList$: Observable<TenantDTO[]>;

  //Tenant Config
  tenantConfig$: Observable<TenantDTO>;

  constructor(
    private tenantService: TenantService,
    private translate: TranslateService,
    private snackbarService: SnackbarService,
    private store: Store<AppState>,
    private dialog: MatDialog
  ) {
    this.tenantConfig$ = this.store.pipe(select(loadedTenantConfigState));
  }

  ngOnInit(): void {
    this.getTenants();
  }

  onSelectedTenantChanges() {
    this.tenantToken.valueChanges.pipe(
      startWith(this.tenantToken.value),
      pairwise()
    ).subscribe(([old, value]) => {
      this.oldTenantToken = old;
      this.newTenantToken = value;
    });
  }

  getTenants() {
    this.tenantList$ = this.tenantService.getTenantsList().pipe(
      map((result) => {
        const { items } = result;
        return items;
      }),
      catchError((error) => {
        this.snackbarService.show({
          message: this.translate.instant("Tenant.tenantsLoadError"),
          type: SnackbarType.ERROR,
        });
        return EMPTY;
      })
    );
  }

  openConfirmationDialog() {
    const dialogData: Dialog = DefaultConfirmationDialogData;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.getSelectedTenant(this.newTenantToken);
        window.location.reload();
        return;
      } 
      this.tenantToken.setValue(this.oldTenantToken);
    });
  }

  getSelectedTenant(token: string) {
    localStorage.setItem("tenant_token", token);
    this.store.dispatch(getTenant({ code: token }));
  }
}
